import { Component, Inject } from '@angular/core';

import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';

@Component({
    selector: 'app-endpoint-link-dialog',
    templateUrl: './endpoint-link-dialog.component.html',
    styleUrls: ['./endpoint-link-dialog.component.scss'],
    standalone: false
})
export class EndpointLinkDialogComponent {
  constructor(
    @Inject(NZ_MODAL_DATA) public data: { endpoint: string, name: string },
    private dialogRef: NzModalRef<EndpointLinkDialogComponent>
  ) { }

  close(): void {
    this.dialogRef.close();
  }
}
